import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConnectionService } from '../.services/connection.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

declare var getScreenConstraints:any;
declare var getMediaElement:any;

@Component({
  selector: 'app-screenshare',
  templateUrl: './screenshare.component.html',
  styleUrls: ['./screenshare.component.css']
})



export class ScreenshareComponent implements OnInit {

  connection: ConnectionService;
  screenshareWindow: any;

  private myTemplate: any = "";

  constructor( private connectionService: ConnectionService, Http: HttpClient) { 
    this.connection = connectionService;
    Http.get("./test.html").subscribe((res)=>{
      this.myTemplate = res;
    });
  }


  closeScreenshare = () => {
    console.log('close')
  }

  joinScreenshare = (roomName) => {
    var roomName: any = 'foo' 
    this.screenshareWindow.contentWindow.postMessage({type: "joinScreenshare", screenshareId: roomName}, "*")

  }

  openScreenshareAsHost = (roomName) => {
    //Tell Iframe to open screenshare

   var roomName:any = 'foo'

    setTimeout(()=> {
      this.screenshareWindow.contentWindow.postMessage({type: "frameScreenshareData", screenshareId: roomName}, "*") //open the screenshare for the host.
      let broadcastScreenshareId = setTimeout(()=>{
          //send ssId to other clients.
        // this.connection.connection.sendCustomMessage({type: "screenshareReq", msg: {requesterId: roomName, screenshareId: roomName, session: this.connection.connection.sessionid}});
      }, 2000)
    }, 3000)
  }

  ngOnInit() {
    this.screenshareWindow = document.getElementById('screenshareWindow');
  }

}
